import React, { Component } from 'react'

export class AdverseEventReporting extends Component {
  render() {
    return (
        <div id="adverse-event-reporting">
        <div className="container">
        <div className="row">
          <div className="section-title text-center"> 
            <h2>Adverse Event Reporting</h2>
          </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-6">
              <p>{this.props.data ? this.props.data.intro1 : 'loading...'}</p>
              <p>{this.props.data ? this.props.data.intro2 : 'loading...'}</p>
              <p>{this.props.data ? this.props.data.contact_intro : 'loading...'}</p>
              <div className="adverse-event-contact">
                <div className="adverse-event-contact-item">
                  <span className="contact-icon" role="img" aria-label="email">📧</span>
                  <span className="contact-label">{this.props.data ? this.props.data.email_label : 'loading...'}</span>
                  <a href={this.props.data ? 'mailto:' + this.props.data.email : '#'}>{this.props.data ? this.props.data.email : ''}</a>
                </div>
                <div className="adverse-event-contact-item">
                  <span className="contact-icon" role="img" aria-label="phone">📞</span>
                  <span className="contact-label">{this.props.data ? this.props.data.phone_label : 'loading...'}</span>
                  <a href={this.props.data ? 'tel:' + this.props.data.phone : '#'}>{this.props.data ? this.props.data.phone : ''}</a>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-md-6">
              <p>{this.props.data ? this.props.data.info_intro : 'loading...'}</p>
              <ul className="adverse-event-list">
                {this.props.data ? this.props.data.info_items.map((item, i) => (
                  <li key={i}>{item}</li>
                )) : 'loading...'}
              </ul>
              <p className="adverse-event-footer">{this.props.data ? this.props.data.footer : 'loading...'}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AdverseEventReporting
